<template>
  <div class="cashback" v-if="cart_items_count">
    <Tips
      v-if="(currentBrand && currentBrand.driver_tips) || !domainBasedBrand"
    ></Tips>
    <template
      v-if="cashback_balance && domainBasedBrand && isModuleEnable('Loyalty')"
    >
      <div class="cashback-card">
        <div class="media">
          <img
            src="/images/checkout/cashback.png"
            class="img-fluid"
            alt="brand"
          />
          <div class="media-body">
            <h6>{{ _T('Cashback Points') }}</h6>
            <p>
              {{ _T('Minimum Order amount should be more then or equal to') }}
              {{ currency }} {{ Num.price(currentBrand.min_order) }}
            </p>
            <hr />
            <p>
              {{ _T('You can redeem') }}
              {{ currency }} {{ Num.price(currentBrand.maximum_redeem) }}
              {{ _T(' maximum loyalty for this order') }}
            </p>
          </div>
        </div>
        <div class="cash-footer">
          <h6>
            {{ _T('Your current cashback balance') }}
            <span>{{ currency }} {{ Num.round(cashback_balance) }}</span>
          </h6>
        </div>
        <div class="cash-footer" v-if="loyalty_spent && !loyalty_error">
          <h6>
            {{ _T('Remaining balance after this transaction') }}
            <span>
              {{ currency }}
              {{
                Num.round(
                  Num.round(cashback_balance) - Num.price(loyalty_spent)
                )
              }}
            </span>
          </h6>
        </div>
        
        <div
          class="cash-footer"
          v-if="loyalty_error || max_spent_loyalty.amount < 0.001"
        >
          <h6 class="text-danger">
            {{
              loyalty_validation_information.msg
                ? loyalty_validation_information.msg
                : _T('Loyalty is not applicable for selected items')
            }}
          </h6>
        </div>
      </div>
      <div
        class="chk-outline"
        v-if="cashback_balance && max_spent_loyalty.amount"
      >
        <label>
          <input
            class="checkbox_animated"
            type="checkbox"
            @click="loyaltyInformationAction"
            v-model="cashbackOnTransaction"
          />
          {{ _T('Use cashback point in this transaction') }}
        </label>
      </div>
    </template>
    <template v-else>
      <!--GO order loyalty setting-->
      <div
        class="chk-outline"
        v-if="cashback_balance && isModuleEnable('Loyalty')"
      >
        <label>
          <input
            class="checkbox_animated"
            type="checkbox"
            @click="loyaltyInformationAction"
            v-model="cashbackOnTransaction"
          />
          {{ _T('Use cashback point in this transaction') }}
        </label>
      </div>
    </template>
    <LoyaltyInformation :loyalty="loyalty_apply"></LoyaltyInformation>
    <Amount></Amount>
    <tips-modal-box></tips-modal-box>
  </div>
</template>
<script>
import Tips from './DriverTips'
import Amount from './Amount'
import TipsModalBox from '@/components/Modals/TipsModalBox'
import { mapGetters } from 'vuex'
import LoyaltyInformation from '@/components/Modals/Payments/LoyaltyInformation'
export default {
  name: 'Cashback',
  components: { LoyaltyInformation, Tips, Amount, TipsModalBox },
  computed: {
    ...mapGetters([
      '_T',
      'cart_items_count',
      'cashback',
      'cashback_balance',
      'loyalty_spent',
      'domainBasedBrand',
      'currentBrand',
      'order_total',
      'isModuleEnable',
      'max_spent_loyalty',
      'loyalty_validation_information',
    ]),
    cashbackOnTransaction: {
      get() {
        return this.$store.state.payment_store.cashbackOnTransaction
      },
      set(val) {
        this.$store.commit('CASHBACK_ON_TRANSACTION', val)
      },
    },
  },
  data() {
    return {
      loyalty_apply: false,
      loyalty_error: false,
    }
  },
  methods: {
    loyaltyInformationAction() {
      // LOYALTY_INFORMATION (commit this according to below conditions
      // if (this.loyalty_spent < 0.01) {
      this.loyalty_error = false
      this.$store.commit('LOYALTY_INFORMATION', { msg: '', amount: 0 })
      if (
        this.currentBrand.min_order > this.order_total &&
        !this.domainBasedBrand
      ) {
        this.loyalty_error = true
        let loyalty_info = {
          msg:
            'Minimum order amount should be more then ' +
            this.currentBrand.min_order,
          amount: 0,
        }
        this.$store.commit('LOYALTY_INFORMATION', loyalty_info)
        this.$store.commit('USER_CHANGE_LOYALTY', 0)
        if (!this.cashbackOnTransaction) {
          this.loyalty_apply = true
          this.$bvModal.show('loyalty-information')
        }
        this.$store.commit('LOYALTY_INFORMATION', { msg: '', amount: 0 })
      } else {
        if (this.currentBrand.min_order > this.order_total) {
          this.loyalty_error = true
          let loyalty_info = {
            msg:
              'Minimum order amount should be more then ' +
              this.currentBrand.min_order,
            amount: 0,
          }
          this.$store.commit('LOYALTY_INFORMATION', loyalty_info)
          this.$store.commit('USER_CHANGE_LOYALTY', 0)
          if (!this.cashbackOnTransaction) {
            this.$bvModal.show('loyalty-information')
          }
          /*document.getElementsByClassName("checkbox_animated").checked = false*/
        } else {
          this.$store.commit('LOYALTY_INFORMATION', { msg: '', amount: 0 })
          // this.$store.commit('USER_CHANGE_LOYALTY', this.loyalty_spent)

          if (!this.cashbackOnTransaction) {
            this.$bvModal.show('loyalty-information')
            this.loyalty_apply = true
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cashback {
  padding-top: calc(
    #{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320))
  );
  border-top: $px1 solid $light-border;
  z-index: 1;
  width: 94.5%;
  margin-bottom: $px90;
  padding-left: 1rem;
  @media (max-width: 767px) {
    width: 100% !important;
    padding: 0.9375rem 1.25rem;
    margin-top: 0.75rem;
    margin-bottom: 0;
  }
  @media (max-width: 575px) {
    background-color: #fff;
    margin-bottom: 0;
  }
  .cashback-card {
    border: $px1 solid $light-border;
    border-radius: $px4;
    @media (max-width: 767px) {
      background-color: $white;
      margin-top: $px12;
    }
    .media {
      padding: $px20;
      .media-body {
        padding-left: $px18;
        h6 {
          font-weight: 600;
          letter-spacing: 0.005em;
          margin-bottom: 0;
        }
        p {
          font-size: $px12;
          line-height: $px15;
          color: $light-font;
          margin-bottom: 0;
        }
      }
    }
    .cash-footer {
      border-top: $px1 solid $light-border;
      padding: $px8 $px20;
      h6 {
        font-weight: 600;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.5px;
        color: $light-font;
        margin-bottom: 0;
        span {
          float: right;
          color: $font-color;
        }
      }
    }
  }
  .chk-outline {
    margin-top: $px10;
    .checkbox_animated {
      margin-right: $px12;
      &:after {
        top: -$px1;
        width: $px18;
        height: $px18;
      }
      &:before {
        left: $px3;
        top: $px4;
      }
    }
    label {
      font-size: $px12;
      line-height: $px15;
      color: $black;
    }
  }
}
</style>
